var render, staticRenderFns
import script from "./DragBox.vue?vue&type=script&lang=js"
export * from "./DragBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('30910e93')) {
      api.createRecord('30910e93', component.options)
    } else {
      api.reload('30910e93', component.options)
    }
    
  }
}
component.options.__file = "src/views/business/components/formSetting/components/form-create-designer/src/components/DragBox.vue"
export default component.exports